module.exports = __webpack_public_path__ + "img/main_cn1.48b74965.svg";